import { apiFetch } from '../lib/api';
import type {
  ClubResponse,
  ClubMemberResponse,
  LeaderboardResponse,
  ClubCatchResponse,
  ContestResponse,
  ContestStandingsResponse,
  CreateClubRequest,
  CreateContestRequest,
  SessionSummary,
  ClubRole,
} from '../types/api';

export function listClubs(): Promise<ClubResponse[]> {
  return apiFetch<ClubResponse[]>('/api/clubs');
}

export function createClub(req: CreateClubRequest): Promise<ClubResponse> {
  return apiFetch<ClubResponse>('/api/clubs', { method: 'POST', body: req });
}

export function getClub(id: number): Promise<ClubResponse> {
  return apiFetch<ClubResponse>(`/api/clubs/${id}`);
}

export function joinClub(inviteCode: string): Promise<ClubResponse> {
  return apiFetch<ClubResponse>('/api/clubs/join', { method: 'POST', body: { inviteCode } });
}

export function leaveClub(id: number): Promise<void> {
  return apiFetch<void>(`/api/clubs/${id}/leave`, { method: 'DELETE' });
}

export function listMembers(clubId: number): Promise<ClubMemberResponse[]> {
  return apiFetch<ClubMemberResponse[]>(`/api/clubs/${clubId}/members`);
}

export function getLeaderboard(clubId: number, type: string): Promise<LeaderboardResponse> {
  return apiFetch<LeaderboardResponse>(`/api/clubs/${clubId}/leaderboard?type=${encodeURIComponent(type)}`);
}

export function getClubCatches(clubId: number): Promise<ClubCatchResponse[]> {
  return apiFetch<ClubCatchResponse[]>(`/api/clubs/${clubId}/catches`);
}

export function listContests(clubId: number): Promise<ContestResponse[]> {
  return apiFetch<ContestResponse[]>(`/api/clubs/${clubId}/contests`);
}

export function getContestStandings(clubId: number, id: number): Promise<ContestStandingsResponse> {
  return apiFetch<ContestStandingsResponse>(`/api/clubs/${clubId}/contests/${id}`);
}

export function createContest(clubId: number, req: CreateContestRequest): Promise<ContestResponse> {
  return apiFetch<ContestResponse>(`/api/clubs/${clubId}/contests`, { method: 'POST', body: req });
}

export function removeMember(clubId: number, userId: string): Promise<void> {
  return apiFetch<void>(`/api/clubs/${clubId}/members/${encodeURIComponent(userId)}`, { method: 'DELETE' });
}

export function getClubSessions(clubId: number): Promise<SessionSummary[]> {
  return apiFetch<SessionSummary[]>(`/api/clubs/${clubId}/sessions`);
}

export function changeMemberRole(
  clubId: number,
  userId: string,
  role: ClubRole,
): Promise<ClubMemberResponse> {
  return apiFetch<ClubMemberResponse>(
    `/api/clubs/${clubId}/members/${encodeURIComponent(userId)}/role`,
    { method: 'PATCH', body: { role } },
  );
}

export function transferOwnership(clubId: number, newOwnerUserId: string): Promise<void> {
  return apiFetch<void>(
    `/api/clubs/${clubId}/transfer-ownership`,
    { method: 'POST', body: { newOwnerUserId } },
  );
}

export function addClubMember(
  clubId: number,
  userId: string,
  role: ClubRole,
): Promise<ClubMemberResponse> {
  return apiFetch<ClubMemberResponse>(`/api/clubs/${clubId}/members`, {
    method: 'POST',
    body: { userId, role },
  });
}
